export default {
  apiKey: 'AIzaSyCSYbEWWKBcbSKgdujRadeYljk-7ArY3Mg',
  authDomain: 'echa--comorebi-notes.firebaseapp.com',
  projectId: 'echa--comorebi-notes',
  storageBucket: 'echa--comorebi-notes.appspot.com',
  messagingSenderId: '567843422288',
  appId: '1:567843422288:web:848c4906689c4890709155'
}
